import React, { useState, useEffect } from "react";
import projects from "../../projects/projects"; // Import projects.js
import { WorkNavData } from "../../projects/projects"; // Reuse same NavData
import Workitem from "./Workitem";
import ScrollTrigger from "react-scroll-trigger";

const Work = () => {
  const [animationOn, setAnimationOn] = useState(false);
  const [item, setItem] = useState({ name: "all" });
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (item.name === "all") {
      setFilteredProjects(projects);
    } else {
      // Filter projects based on category
      const newProjects = projects.filter((project) => {
        return project.category === item.name;
      });
      setFilteredProjects(newProjects);
    }
  }, [item]);


  const handleClick = (e, ind) => {
    setItem({ name: e.target.textContent });
    setActive(ind);
  };



  return (
    <div className="portfolioContent">
      <div className="workFilters">
        {WorkNavData.map((nav, ind) => {
         
          const { name } = nav;
          return (
         
            <span
              onClick={(e) => handleClick(e, ind)}
              key={ind}
              className={active !== ind ? "workNavItem" : "workNavItem activeBar"}
            >
             
              {name}
              
            </span>
            
          );
        })  
        }
        
      </div>
      {console.log('active', active,)}

      <ScrollTrigger
        onEnter={() => setAnimationOn(true)}
        onExit={() => setAnimationOn(false)}
      >
        {animationOn && (
          <div className="projects animate__animated animate__flipInX">
            {filteredProjects.map((work) => {
              return <Workitem work={work} key={work.id} />;
            })}
          </div>
        )}
      </ScrollTrigger>
    </div>
  );
};

export default Work;
